import React from "react";
import { Card, Form, Input, Button, Switch, Divider, message } from "antd";
import { SettingOutlined, SaveOutlined } from "@ant-design/icons";
import "./Settings.css";

function Settings() {
  const [form] = Form.useForm();

  const handleSave = (values) => {
    console.log("Settings saved:", values);
    message.success("Settings saved successfully!");
  };

  return (
    <div className="settings-page">
      <div className="page-header">
        <div>
          <h2 className="page-title"><SettingOutlined /> Settings</h2>
          <p className="page-subtitle">Configure site settings</p>
        </div>
      </div>

      <Form form={form} layout="vertical" onFinish={handleSave}
        initialValues={{
          site_name: "Matrimonial",
          site_email: "admin@matrimonial.com",
          enable_registration: true,
          enable_notifications: true,
        }}>

        <Card title="Site Settings" className="settings-card">
          <Form.Item name="site_name" label="Site Name">
            <Input placeholder="Site name" />
          </Form.Item>
          <Form.Item name="site_email" label="Site Email">
            <Input type="email" placeholder="admin@site.com" />
          </Form.Item>
          <Form.Item name="site_contact" label="Contact Number">
            <Input placeholder="+91 9876543210" />
          </Form.Item>
          <Form.Item name="site_address" label="Address">
            <Input.TextArea rows={2} />
          </Form.Item>
        </Card>

        <Card title="Features" className="settings-card">
          <Form.Item name="enable_registration" label="Enable Registration" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item name="enable_notifications" label="Enable Notifications" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item name="enable_chat" label="Enable Chat" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Card>

        <Card title="SEO Settings" className="settings-card">
          <Form.Item name="meta_title" label="Meta Title">
            <Input placeholder="Site meta title" />
          </Form.Item>
          <Form.Item name="meta_description" label="Meta Description">
            <Input.TextArea rows={3} placeholder="Site description..." />
          </Form.Item>
          <Form.Item name="meta_keywords" label="Meta Keywords">
            <Input placeholder="keyword1, keyword2, ..." />
          </Form.Item>
        </Card>

        <div className="settings-actions">
          <Button type="primary" htmlType="submit" icon={<SaveOutlined />}
            size="large" style={{ background: "#ff0055", borderColor: "#ff0055" }}>
            Save Settings
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default Settings;